(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  var SEL = 'hero-banner.hero, .product-details-section';
  function apply() {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      els[i].style.removeProperty('min-height');
      els[i].style.setProperty('min-height', els[i].getBoundingClientRect().height + 'px', 'important');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  window.addEventListener('load', apply);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply);
  window.addEventListener('orientationchange', function () {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) els[i].style.removeProperty('min-height');
    setTimeout(apply, 400);
  });
})();